"use strict";const o=(t,n=document.body,r)=>{let e=document.querySelector(t);return e||(e=r?r():document.createElement(t),n.insertBefore(e,n.firstChild))};export default o;
//# sourceMappingURL=getSingletonElementInstance.js.map
